// src/api/auth.js
import http from '@/utils/http'

// 注册接口
export function registerApi(data) {
  return http({
    url: '/api/v1/auth/register',
    method: 'post',
    data
  })
}

// 登录接口
export function loginApi(data) {
  return http({
    url: '/api/v1/auth/login',
    method: 'post',
    data
  })
}

export function getDeviceList() {
  return http({
    url: '/api/v1/device/list',
    method: 'get',
  })
}

export function updateDeviceNames(data) {
  return http({
    url: '/api/v1/device/updateNames',
    method: 'post',
    data
  })
}

export function updateGroupNames(data) {
  return http({
    url: '/api/v1/device-group/updateNames',
    method: 'post',
    data
  })
}

export function getDeviceToGroupMapList(data) {
  return http({
    url: '/api/v1/device-group-map/list',
    method: 'get',
    data
  })
}

export function getDeviceAlarms() {
  return http({
    url: '/api/v1/device-alarm/list',
    method: 'get',
  })
}

export function getDeviceToGroupList(data) {
  return http({
    url: '/api/v1/device-group/list',
    method: 'get',
    data
  })
}

export function addDeviceToGroup(data) {
  return http({
    url: '/api/v1/device-group-map/addDevice',
    method: 'post',
    data
  })
}

export function removeGroupDevice(data) {
  return http({
    url: '/api/v1/device-group-map/removeDevice',
    method: 'post',
    data
  })
}

export function getTaskByGroupId(groupId) {
  return http({
    url: '/api/v1/schedule-task/list/'+groupId,
    method: 'get',
  })
}

export function updateTaskTime(data) {
  return http({
    url: '/api/v1/schedule-task/update-time/',
    method: 'post',
    data
  })
}

// 假设后端使用 GET 请求来播放音频
export function playMusic(deviceId, fileName) {
  return http({
    url: `/api/v1/file/music/play/${deviceId}/${fileName}`,  // 拼接设备 ID 和文件名到 URL
    method: 'get',
    responseType: 'blob'  // 确保我们获取二进制数据
  });
}
